// extracted by mini-css-extract-plugin
export default {"container":"sectionHeader_container__+jMJH","badge":"sectionHeader_badge__BEUyK","title":"sectionHeader_title__FnLHL"};